<template>
  <!-- <div class="BottomNavigation">
    <div style="max-width: 1400px;margin: 0 auto;">
      <el-row>
        <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
          <div class="flex">
            <div class="item">
              <div class="title">关于联合</div>
              <p>了解我们</p>
              <p>联系我们</p>
            </div>
            <div class="item">
              <div class="title">关注联合</div>
              <p>新浪微博</p>
              <p>新闻中心</p>
            </div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
          <div class="flex center">
            <div>
              <img src="../assets/gzh.jpg" style="width: 107px;height: 107px;" alt="">
              <p style="color: #ffffff;font-size: 16px;text-align: center;">微信公众号</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <div style="color: #FFFFFF;margin-left: 46px;">
            地址：浙江省丽水市莲都区古城路163号二楼
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="18">
          <div style="color: #FFFFFF;margin-left: 46px;">
            服务热线： 400-622-1988
          </div>
        </el-col>
      </el-row>

    </div>
  </div> -->


  <!-- <div class="beian">
    <div style="width:800px;margin:0 auto; padding:20px 0;">


      <div href="" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img src="../../public/img/icp.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px;color:#939393; "><a
            style="color:#939393;" target="_blank"
            href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33110202000576">浙公网安备
          33110202000576</a>
          <a target="_blank" style="margin-left: 10px;color:#939393;" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备14007572号-3</a>
          @2019 浙江联合创展科技股份有限公司 版权所有</p></div>
    </div>




  </div> -->

  <div class="bottom-navigation-box">
    <div class="content-box">
      <div class="left-box">
        <img class="logo-img-box" src="../assets/footer_logo.png" alt="">
        <div class="text-box">
          <span @click="goToNavigate(1)">关于我们</span>
          <span @click="goToNavigate(2)">合作与生态</span>
          <span @click="goToNavigate(3)">联合动态</span>
          <span @click="goToNavigate(4)">加入我们</span>
          <span @click="goToNavigate(5)">主营业务</span>
        </div>
      </div>
      <div class="center-box">
        <img src="../assets/gzh.jpg" alt="">
        <span>联合创展公众号</span>
      </div>
      <div class="right-box">
        <span>服务热线</span>
        <span>400-622-1988</span>
        <span>公司地址</span>
        <span>浙江省丽水市莲都区古城路163号二楼</span>
      </div>
    </div>
    <div class="license-box">
      <img src="../../public/img/icp.png"/>
      <span>
        <a style="color: #CBCACA" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33110202000576" target="_blank">浙公网安备 33110202000576 </a>
        <a style="color: #CBCACA" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"> 浙ICP备14007572号-3</a>
         @2019 浙江联合创展科技股份有限公司 版权所有
      </span>
    </div>
  </div>

</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'BottomNavigation',
  data() {
    return {
      router: useRouter()
    }
  },
  created() {

  },
  methods: {
    goToNavigate(val) {
      if (val === 1) {
        this.router.push('/about')
      } else if (val === 2) {
        this.router.push('/cooperation')
      } else if (val === 3) {
        this.router.push('/news')
      } else if (val === 4) {
        this.router.push('/Joinus')
      } else if (val === 5) {
        this.router.push('/business')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bottom-navigation-box {
  background-color: #18181a;
  color: white;
  padding: 25px 15px 20px; /* 小屏缩减内边距，避免拥挤；左右防贴边 */
  box-sizing: border-box;

  // 核心内容区（左logo+中公众号+右联系方式）
  .content-box {
    margin: 0 auto;
    max-width: 1200px;
    height: auto;
    display: flex;
    flex-direction: column; /* 小屏垂直排列（1列） */
    align-items: center; /* 小屏内容居中 */
    gap: 30px; /* 小屏模块间距，避免拥挤 */
    margin-bottom: 25px; /* 缩减底部间距（原30px） */

    // 左侧：logo+导航文字
    .left-box {
      color: white;
      display: flex;
      flex-direction: column;
      align-items: center; /* 小屏logo与文字居中 */

      .logo-img-box {
        width: 140px; /* 缩减logo宽度（原160px），适配小屏 */
        height: 40px; /* 取消固定高度，保持比例 */
        margin-bottom: 20px; /* 缩减logo与文字间距（原35px） */
      }

      .text-box {
        width: 100%;
        max-width: 280px; /* 限制最大宽度，避免小屏过宽 */
        display: flex;
        flex-wrap: wrap;
        justify-content: center; /* 小屏导航文字居中 */
        gap: 10px 15px; /* 调整间距（上下10px，左右15px），适配小屏 */
        font-size: 14px; /* 缩减字体（原16px），避免拥挤 */

        span {
          width: 80px; /* 取消固定宽度（原80px），自适应文字 */
          // padding: 0 5px; /* 增加内边距，提升点击区域 */
          cursor: pointer;
        }
      }
    }

    // 中间：公众号图片+文字
    .center-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px; /* 缩减间距（原14px），适配小屏 */
      position: static; /* 取消原top定位，小屏无需偏移 */

      img {
        width: 90px; /* 缩减图片宽度（原108px），适配小屏 */
        height: 90px; /* 保持正方形比例 */
      }

      span {
        font-size: 13px; /* 缩减字体（原14px），适配小屏 */
      }
    }

    // 右侧：联系方式
    .right-box {
      display: flex;
      flex-direction: column;
      align-items: center; /* 小屏联系方式居中 */
      gap: 10px; /* 缩减间距（原13px），适配小屏 */
      font-size: 14px; /* 缩减字体（原16px），适配小屏 */
      position: static; /* 取消原top定位，小屏无需偏移 */
      text-align: center; /* 小屏文字居中，提升可读性 */

      span:nth-child(2) {
        font-size: 20px; /* 缩减电话字体（原24px），适配小屏 */
      }
    }
  }

  // 底部：备案信息
  .license-box {
    width: 100%;
    border-top: 1px solid #323232;
    display: flex;
    flex-direction: column; /* 小屏垂直排列（图片在上，文字在下） */
    justify-content: center;
    align-items: center;
    padding-top: 15px; /* 缩减顶部内边距（原20px），适配小屏 */
    gap: 8px; /* 小屏图片与文字间距 */

    img {
      width: 20px;
      height: 20px;
      margin-right: 0; /* 取消右侧margin，小屏垂直排列无需偏移 */
    }

    span {
      font-size: 12px; /* 缩减字体（原15px），适配小屏 */
      color: #CBCACA;
      text-align: center; /* 小屏备案文字居中，避免换行混乱 */
      line-height: 1.5; /* 优化行高，提升多行可读性 */
      padding: 0 5px; /* 增加左右内边距，避免文字贴边 */
    }

    // 备案链接样式（继承父级颜色，保持一致性）
    a {
      color: inherit;
      text-decoration: none; /* 清除默认下划线，提升视觉 */

      &:hover {
        text-decoration: underline; /* hover加下划线，提示可点击 */
      }
    }
  }

  // --------------------------
  // 中屏（768px-1199px）：2列布局，适配平板
  // --------------------------
  @media (min-width: 768px) and (max-width: 1199px) {
    padding: 30px 20px 24px; /* 增加内边距，比小屏宽松 */

    .content-box {
      flex-direction: row; /* 中屏横向排列（2列：左列+右列） */
      flex-wrap: wrap; /* 自动换行，避免溢出 */
      justify-content: space-around; /* 内容均匀分布 */
      gap: 25px;
      margin-bottom: 28px;

      .left-box {
        order: 1; /* 左侧模块排序1 */
        flex: 1 1 40%; /* 占40%宽度 */

        .logo-img-box {
          width: 150px; /* 增大logo宽度，接近原设计 */
          max-height: 43px;
          margin-bottom: 25px;
        }

        .text-box {
          max-width: 220px;
          justify-content: space-between; /* 恢复左右分布 */
          font-size: 15px;
          gap: 11px;
        }
      }

      .center-box {
        order: 3; /* 中间模块排序3（换行到第二行） */
        flex: 1 1 100%; /* 占100%宽度，居中显示 */
        gap: 13px;

        img {
          width: 100px; /* 增大图片宽度，接近原设计 */
          height: 100px;
        }

        span {
          font-size: 14px;
        }
      }

      .right-box {
        order: 2; /* 右侧模块排序2 */
        flex: 1 1 40%; /* 占40%宽度 */
        align-items: flex-end; /* 右侧文字右对齐，提升布局平衡 */
        text-align: right; /* 文字右对齐 */
        gap: 12px;
        font-size: 15px;

        span:nth-child(2) {
          font-size: 22px; /* 增大电话字体，接近原设计 */
        }
      }
    }

    .license-box {
      flex-direction: row; /* 中屏恢复横向排列（图片+文字） */
      padding-top: 18px;
      gap: 6px;

      img {
        margin-right: 6px; /* 恢复右侧margin，匹配原设计 */
      }

      span {
        font-size: 13px; /* 增大字体，接近原设计 */
        text-align: left; /* 文字左对齐 */
      }
    }
  }

  // --------------------------
  // 大屏（≥1200px）：3列布局，还原原设计
  // --------------------------
  @media (min-width: 1200px) {
    padding: 30px 0 26px; /* 恢复原内边距 */

    .content-box {
      flex-direction: row; /* 大屏横向排列（3列） */
      justify-content: space-between; /* 两端对齐，匹配原设计 */
      flex-wrap: nowrap; /* 禁止换行，保持3列完整 */
      gap: 0;
      margin-bottom: 30px;

      .left-box {
        align-items: flex-start; /* 左侧内容左对齐 */

        .logo-img-box {
          width: 160px; /* 恢复原宽度 */
          height: 46px; /* 恢复原高度 */
          margin-bottom: 35px;
        }

        .text-box {
          width: 190px; /* 恢复原宽度 */
          justify-content: space-between;
          font-size: 16px;
          gap: 12px;

          span {
            width: 80px; /* 恢复原固定宽度 */
          }
        }
      }

      .center-box {
        position: relative;
        top: 18px; /* 恢复原top定位 */
        gap: 14px;

        img {
          width: 108px; /* 恢复原宽度 */
          height: 108px; /* 恢复原高度 */
        }

        span {
          font-size: 14px; /* 恢复原字体 */
        }
      }

      .right-box {
        position: relative;
        top: 14px; /* 恢复原top定位 */
        align-items: flex-start; /* 右侧内容左对齐 */
        text-align: left; /* 文字左对齐 */
        gap: 13px;
        font-size: 16px; /* 恢复原字体 */

        span:nth-child(2) {
          font-size: 24px; /* 恢复原字体 */
        }
      }
    }

    .license-box {
      flex-direction: row; /* 保持横向排列 */
      padding-top: 20px; /* 恢复原内边距 */

      img {
        margin-right: 6px; /* 恢复原margin */
      }

      span {
        font-size: 15px; /* 恢复原字体 */
      }
    }
  }
}



.beian {
  font-size: 15px;
  text-align: center;
  padding: 20px 5px;
  background-color: #404243;
  color: #FFFFFF;
}

.BottomNavigation {

  .item {
    .title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 19px;
    }

    p {
      margin-bottom: 8px;
      font-size: 14px;
    }

    color: #FFFFFF;
    margin-left: 46px;
  }

  width: 100%;
  background-color: #575A5B;
  padding: 44px 0;
}
</style>
